import useEnv from '@zenbusiness/application-commons-env';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { DISCLOSURES_TEXT } from '#client/constants/text';
import useBreakpoints from '#client/hooks/useBreakpoints';

export default function Footer() {
  const { RELEASE_VERSION } = useEnv('head-first');
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <Stack
      mb="4px"
      paddingTop={isDesktop ? '104px' : '80px'}
    >
      <Text
        align="left"
        color="tertiary"
        size="xs"
        sx={{
          lineHeight: '16px'
        }}
      >
        {`${DISCLOSURES_TEXT} Release ${RELEASE_VERSION}`}
      </Text>
    </Stack>
  );
}
